import { useEffect, useState } from 'react';
import { Button, Input } from '@/components/ui/form';
import { useAudioListStore } from '@/state/audio-list-store';
import { useForm } from 'react-hook-form';
import { postSuperVoiceTrain, generateFromSuperVoice } from '@/service/generatorv2';
import { useRequest } from 'ahooks';
import { toast } from 'sonner';
import { useSessionStore } from '@/hooks/useSessionStore';
import { useAuthCheck } from '@/hooks/useAuthCheck';
import { useModel } from '../Home/Generator/model';

const fileCount = 5;

const SuperVoiceTest = () => {
  useModel();
  const sessionStore = useSessionStore();
  const { session } = sessionStore;
  const { isAuth } = useAuthCheck();

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();
  const { selectedInfo } = useAudioListStore();
  const [loading, setLoading] = useState(false);

  const { run: runPostSuperVoiceTrain, loading: superVoiceTrainLoading } = useRequest(postSuperVoiceTrain, {
    manual: true,
    onSuccess: (data) => {},
    onError: (error) => {
      toast.error(String(error) ?? 'Unknown Error.');
    },
    debounceWait: 500,
  });

  const { run: runGenerateFromSuperVoice, loading: generateFromSuperVoiceLoading } = useRequest(generateFromSuperVoice, {
    manual: true,
    onSuccess: (data) => {},
    onError: (error) => {
      toast.error(String(error) ?? 'Unknown Error.');
    },
    debounceWait: 500,
  });

  const onSubmit = (v: any) => {
    console.log(v);
    const postFormData = new FormData();
    new Array(fileCount).fill(0).map((_, index) => {
      if (v[`track_${index}`][0]) {
        postFormData.append('files', v[`track_${index}`][0]);
      }
    });
    postFormData.append('name', v.name);
    runPostSuperVoiceTrain(postFormData);
  };

  const onInferenceSubmit = (v: any) => {
    console.log(v);
    const postFormData = new FormData();
    postFormData.append('file', v[`file`][0]);
    runGenerateFromSuperVoice(postFormData, v.id);
  };

  if (!isAuth || !session.user.permissions.find((i) => i.code === 'VIEW_SUPER_TESTER')) {
    return null;
  }

  return (
    <div className={'flex h-lvh'}>
      <div className="flex-1 px-2 pt-2 h-lvh overflow-y-auto relative">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Button>Train</Button>
          {!loading && (
            <>
              <div className={'flex gap-2 mb-2'}>
                <div className={'w-44 text-right leading-10'}>name:</div>
                <div className={'flex-1 content-center'}>
                  <div className={'flex-1'}>
                    <Input {...register('name')} defaultValue={''} />
                  </div>
                </div>
              </div>
              {new Array(fileCount).fill(0).map((_, index) => {
                return (
                  <div className={'flex gap-2 mb-2'}>
                    <div className={'w-44 text-right leading-10'}>Track{index}:</div>
                    <div className={'flex-1 content-center'}>
                      <div className={'flex-1'}>
                        <Input type="file" {...register(`track_${index}`)} />
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </form>
      </div>

      <div className="flex-1 px-2 pt-2 h-lvh overflow-y-auto relative">
        <form onSubmit={handleSubmit(onInferenceSubmit)}>
          <Button>inference</Button>
          {!loading && (
            <>
              <div className={'flex gap-2 mb-2'}>
                <div className={'w-44 text-right leading-10'}>id:</div>
                <div className={'flex-1 content-center'}>
                  <div className={'flex-1'}>
                    <Input {...register('id')} defaultValue={''} />
                  </div>
                </div>
              </div>
              <div className={'flex gap-2 mb-2'}>
                <div className={'w-44 text-right leading-10'}>Track:</div>
                <div className={'flex-1 content-center'}>
                  <div className={'flex-1'}>
                    <Input type="file" {...register(`file`)} />
                  </div>
                </div>
              </div>
            </>
          )}
        </form>
      </div>
    </div>
  );
};

export default SuperVoiceTest;
